import { motion } from "framer-motion";
import { fadeUp, viewport } from "../lib/motion";

// Small uppercase eyebrow label used above section headings
export const SectionLabel = ({ children, className = "" }) => (
  <motion.p
    variants={fadeUp}
    initial="hidden"
    whileInView="show"
    viewport={viewport}
    className={`text-xs sm:text-sm uppercase tracking-label font-semibold text-primary mb-4 flex items-center gap-3 ${className}`}
    data-testid="section-label"
  >
    <span className="inline-block h-px w-8 bg-highlight" />
    {children}
  </motion.p>
);

export const SectionHeading = ({ children, className = "" }) => (
  <motion.h2
    variants={fadeUp}
    initial="hidden"
    whileInView="show"
    viewport={viewport}
    className={`font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.1] text-foreground ${className}`}
  >
    {children}
  </motion.h2>
);
